import React from "react";
import { fileUrl } from "../../api";

export default function WiresPanel({ integrations }) {
  const email = integrations?.email || {};
  const news = integrations?.newsletter || {};

  return (
    <section className="admin-sec" data-testid="admin-wires-panel">
      <header>
        <h2>Wires</h2>
      </header>
      <p className="admin-help">
        Nothing here is magic &mdash; it&rsquo;s just wires. Both of these are
        optional. While they&rsquo;re off, every RSVP, note and signup still lands
        safely in this dashboard; you just have to come and look rather than being
        told. Switch one on by adding its key to the server&rsquo;s settings file
        and restarting.
      </p>

      <div className="wires">
        <div className="wire" data-testid="admin-wire-email">
          <div className="wtop">
            <h3>Email notifications</h3>
            <span className={`chip ${email.configured ? "chip--on" : "chip--off"}`}>
              {email.configured ? "Connected" : "Not connected"}
            </span>
            <span className="chip">{email.provider}</span>
          </div>
          {email.configured ? (
            <p>
              Working. You&rsquo;ll get an email the moment someone RSVPs or writes
              in, sent from <code>{email.sender}</code>
              {email.notify_to ? (
                <>
                  {" "}
                  to <code>{email.notify_to}</code>
                </>
              ) : (
                <>
                  {" "}
                  &mdash; though <code>NOTIFY_EMAIL</code> is still blank, so
                  there&rsquo;s nowhere to send it. Add your address.
                </>
              )}
              . People also get a confirmation.
            </p>
          ) : (
            <p>
              Off, so you won&rsquo;t be notified &mdash; but nothing is lost.
              Resend&rsquo;s free tier is 3,000 emails a month, which is far more
              than this will use. Sign up at resend.com, make an API key, then add{" "}
              <code>RESEND_API_KEY</code> and <code>NOTIFY_EMAIL</code> to{" "}
              <code>backend/.env</code> and restart. Nothing else changes.
            </p>
          )}
        </div>

        <div className="wire" data-testid="admin-wire-newsletter">
          <div className="wtop">
            <h3>Newsletter list</h3>
            <span className={`chip ${news.configured ? "chip--on" : "chip--off"}`}>
              {news.configured ? "Connected" : "Not connected"}
            </span>
            <span className="chip">{news.provider}</span>
          </div>
          {news.configured ? (
            <p>
              Working. Signups are added to list <code>{news.list_id}</code>{" "}
              automatically, and they&rsquo;re still stored here too.
            </p>
          ) : (
            <p>
              Off. Signups are being kept on this site and you can export them as a
              CSV that drops straight into EmailOctopus. To automate it, add{" "}
              <code>EMAILOCTOPUS_API_KEY</code> and{" "}
              <code>EMAILOCTOPUS_LIST_ID</code> to <code>backend/.env</code> and
              restart. Note their API v2 needs a key created after 7 October 2024.
            </p>
          )}
        </div>

        <div className="wire" data-testid="admin-wire-pdf">
          <div className="wtop">
            <h3>The Rule, as a PDF</h3>
            <span className="chip chip--on">Working</span>
          </div>
          <p>
            Typeset fresh every time somebody downloads it, straight from the same
            text the website shows &mdash; so the printed version can never fall out
            of date. US Letter, in the right typefaces.{" "}
            <a className="linkish" href={fileUrl("/rule/pdf")}>
              Have a look
            </a>
          </p>
        </div>

        <div className="wire" data-testid="admin-wire-calendar">
          <div className="wtop">
            <h3>Calendar files</h3>
            <span className="chip chip--on">Working</span>
          </div>
          <p>
            Every gathering gets its own &ldquo;add to calendar&rdquo; file built
            from the date you typed, plus one feed for the whole season. If you tick
            &ldquo;keep the address off the public page&rdquo;, the address stays out
            of the calendar file too.{" "}
            <a className="linkish" href={fileUrl("/gatherings/calendar.ics")}>
              The season feed
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
